import { TGlobalSettingBEResponseSchema } from '@onesource/schemas';
import { queryOptions, useQuery } from '@tanstack/react-query';

import axios from '../axios';

const ENTITY = 'settings';

export const getGlobalSettingsQueryKey = () => [ENTITY, 'global'];

export const getGlobalSettingsQueryOptions = () =>
  queryOptions<Partial<TGlobalSettingBEResponseSchema>>({
    queryKey: getGlobalSettingsQueryKey(),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const res = await axios.get<Partial<TGlobalSettingBEResponseSchema>>(ENTITY);
      return res.data;
    },
  });

export const useGetGlobalSettingsQuery = () => useQuery(getGlobalSettingsQueryOptions());
